import { HeaderCellProps } from '../types';

export const TenantArchivedAtHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Archived At</div>;
};
